export function seislevel(seis) {
    var s = Number(seis);
    var ret;
    if (s >= 6.5) {
      ret = "7";
    } else if (s >= 6.0 && s < 6.5) {
      ret = "6+";
    } else if (s >= 5.5 && s < 6.0) {
      ret = "6-";
    } else if (s >= 5.0 && s < 5.5) {
      ret = "5+";
    } else if (s >= 4.5 && s < 5.0) {
      ret = "5-";
    } else if (s >= 3.5 && s < 4.5) {
      ret = "4";
    } else if (s >= 2.5 && s < 3.5) {
      ret = "3";
    } else if (s >= 1.5 && s < 2.5) {
      ret = "2";
    } else if (s >= 0.5 && s < 1.5) {
      ret = "1";
    } else {
      ret = "0";
    }
    return ret;
}

export function seisleveljp(seis) {
    return seislevel(seis).replace("+","強").replace("-","弱");
}